import React, { FC, useEffect } from 'react';
import Modal from 'antd/lib/modal/Modal';
import { Form, Spin } from 'antd';
import { MainReducerState } from '../../../store/reducers';
import { connect } from 'react-redux';
import { FormProps } from 'antd/lib/form';
import { RouteProps } from 'react-router-dom';
import { DrawerProps } from 'antd/lib/drawer';
import { ButtonProps } from 'antd/lib/button';

import {
    NotificationsState,
    details as notificationDetails,
    update as notificationUpdate,
    create as notificationCreate,
} from '../../../store/actions/notifications';
import LibraryNotificationFilterSelect from './LibraryNotificationFilterSelect';

const requiredRule = { required: true, message: 'Ce champ est obligatoire' };

interface NotificationModalProps extends RouteProps {
    isVisible: boolean;
    onClose: () => void;
    onSuccess?: (payload: any) => void;

    notifications: NotificationsState;
    getDetails: typeof notificationDetails.trigger;
    detailsReset: typeof notificationDetails.reset;
    update: typeof notificationUpdate.trigger;
    updateReset: typeof notificationUpdate.reset;
    create: typeof notificationCreate.trigger;
    createReset: typeof notificationCreate.reset;
}

const NotificationModal: FC<NotificationModalProps> = ({
    isVisible,
    onClose,
    onSuccess,

    notifications,
}) => {

    const [form] = Form.useForm();

    useEffect(() => {
        if (isVisible) {
            form.resetFields();
        }
    }, [isVisible, form]);

    const onFormFinish: FormProps['onFinish'] = (values) => {
        form.validateFields().then(() => {
            if (onSuccess) { onSuccess(values); }
        });
    };

    const onDrawerClose: DrawerProps['onClose'] & ButtonProps['onClick'] = () => {
        onClose();
        form.resetFields();
    };

    return (
        <Modal
            className="select-modal"
            title={'Ajouter une notification'}
            width={500}
            onCancel={onDrawerClose}
            centered
            visible={isVisible}
            destroyOnClose={true}
            okText={'Valider'}
            okButtonProps={{
                type: 'primary',
                shape: 'round',
            }}
            cancelText={'Annuler'}
            cancelButtonProps={{
                shape: 'round',
            }}
            onOk={form.submit}
        >
            <Spin spinning={notifications.details.loading}>
                <Form
                    form={form}
                    onFinish={onFormFinish}
                    layout="vertical"
                    hideRequiredMark
                >
                    <Form.Item
                        name="notifications"
                        rules={[requiredRule]}
                    >
                        <LibraryNotificationFilterSelect
                            size="large"
                            multi={false}
                            filters={{
                                filters: [
                                    {name: 'program', value: 'none'}, // Get library notifications (not assigned to a program)
                                ],
                            }}
                        />
                    </Form.Item>
                </Form>
            </Spin>
        </Modal>
    );

};

const mapStateToProps = (state: MainReducerState) => ({
    notifications: state.notifications,
});

export default connect(
    mapStateToProps,
    {
        getDetails: notificationDetails.trigger,
        detailsReset: notificationDetails.reset,
        create: notificationCreate.trigger,
        createReset: notificationCreate.reset,
        update: notificationUpdate.trigger,
        updateReset: notificationUpdate.reset,
    },
)(NotificationModal);
